<template>
	<div class="container">
		<div class="row" id="header-row">
			<nav class="navbar navbar-expand-sm navbar-light bg-white">
		        <a class="navbar-brand" href="#">
					<img src="img/wgaca-logo-black.png" alt="What Goes Around Comes Around">
		        </a>
			    <button class="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#headerNav" aria-controls="headerNav" aria-expanded="false" aria-label="Toggle navigation">
			      <span class="navbar-toggler-icon"></span>
			    </button>
			    <div class="collapse navbar-collapse" id="headerNav">
			        <ul class="navbar-nav content-tabs mr-auto mt-2 mt-lg-0">
				        <li class="nav-item nav-tab-item nav-tab-item">
				          <a class="nav-link active" @click="setTab" data-tab="checkout" href="#checkout">Checkout</a>
				        </li>
				        <li class="nav-item nav-tab-item d-inline-block d-sm-none d-lg-inline-block">
				          <a class="nav-link" @click="setTab" data-tab="orders" href="#">Orders</a>
				        </li>
				        <li class="nav-item nav-tab-item d-inline-block d-sm-none d-lg-inline-block">
				          <a class="nav-link" @click="setTab" data-tab="invoices" href="#">Invoices</a>
				        </li>
				        <li class="nav-item nav-tab-item d-inline-block d-sm-none d-lg-inline-block">
				          <a class="nav-link" @click="setTab" data-tab="layaway" href="#">Layaway</a>
				        </li>
				        <li class="nav-item nav-tab-item d-inline-block d-sm-none d-lg-inline-block">
				          <a class="nav-link" @click="setTab" data-tab="customers" href="#">Customers</a>
				        </li>
				        <li class="nav-item nav-tab-item d-inline-block d-sm-none d-xl-inline-block">
				          <a class="nav-link" @click="setTab" data-tab="transfers" href="#">Transfers</a>
				        </li>
				        <li class="nav-item nav-tab-item d-inline-block d-sm-none d-xl-inline-block">
				          <a class="nav-link" @click="setTab" data-tab="offsite" href="#">Offsite</a>
				        </li>
				        <li class="nav-item dropdown d-none d-sm-inline-block d-xl-none">
				          <a class="nav-link dropdown-toggle" href="#" id="headerNavMoreDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
				            More
				          </a>
				          <ul class="dropdown-menu" aria-labelledby="headerNavMoreDropdown">
					        <li class="nav-item nav-tab-item d-none d-sm-inline-block d-lg-none">
					          <a class="nav-link" @click="setTab" data-tab="orders" href="#">Orders</a>
					        </li>
					        <li class="nav-item nav-tab-item d-none d-sm-inline-block d-lg-none">
					          <a class="nav-link" @click="setTab" data-tab="invoices" href="#">Invoices</a>
					        </li>
					        <li class="nav-item nav-tab-item d-none d-sm-inline-block d-lg-none">
					          <a class="nav-link" @click="setTab" data-tab="layaway" href="#">Layaway</a>
					        </li>
					        <li class="nav-item nav-tab-item d-none d-sm-inline-block d-lg-none">
					          <a class="nav-link" @click="setTab" data-tab="customers" href="#">Customers</a>
					        </li>
					        <li class="nav-item nav-tab-item d-none d-sm-inline-block">
					          <a class="nav-link" @click="setTab" data-tab="transfers" href="#">Transfers</a>
					        </li>
					        <li class="nav-item nav-tab-item d-none d-sm-inline-block">
					          <a class="nav-link" @click="setTab" data-tab="offsite" href="#">Offsite</a>
					        </li>
				          </ul>
				        </li>
			        </ul>
					<div class="btn-group ms-auto flex-nowrap">
						<div class="btn btn-lg"><i class="bi-gear-wide-connected"></i></div>
						<div class="btn btn-lg"><i class="bi-question-circle-fill"></i></div>
					</div>
			    </div>
			</nav>
		</div>
		<div class="row">
			<div class="col">
				<div class="content-tab active" id="checkout">
					<checkout />
				</div>
				<div class="content-tab" id="orders"></div>
				<div class="content-tab" id="invoices"></div>
				<div class="content-tab" id="layaway"></div>
				<div class="content-tab" id="customers"></div>
				<div class="content-tab" id="transfers"></div>
				<div class="content-tab" id="offsite"></div>
			</div>
		</div>
	</div>
</template>
<script>
import { Tooltip, Toast, Popover } from 'bootstrap';
import Vue from 'vue';
import Vuex from 'vuex';
import checkout from './POS/Checkout';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    count: 0
  },
  mutations: {
    increment (state) {
      state.count++
    }
  }
});

var POS = {
	components:  { checkout },
	store,
	methods: {
		setTab (el) {
			var tabName = el.target.dataset.tab;
			// deselect old tabs / content
			document.querySelector('#headerNav > ul > li.nav-tab-item a.active').parentNode.classList.add("d-sm-none");
			document.querySelectorAll('#headerNav li.nav-tab-item a.active').forEach(e => e.classList.remove("active"));
			document.querySelector('.content-tab.active').classList.remove("active");
			
			// select new tabs / content
			document.querySelector('#' + tabName + '.content-tab').classList.add("active");
			document.querySelectorAll('#headerNav li.nav-tab-item a[data-tab="' + tabName + '"]').forEach(e => e.classList.add("active"));
			document.querySelector('#headerNav > ul > li.nav-tab-item a.active').parentNode.classList.remove("d-sm-none");
			
			// ensure checkout tab is always visible
			document.querySelector('#headerNav li.nav-tab-item a[data-tab="checkout"]').parentNode.classList.remove("d-sm-none");
		}
	}
};

export default POS;

</script>
<style>
  @import '/css/pos.css';
</style>